import { gql } from "@apollo/client";

const SUBSCRIBE_INSTAGRAM_PAGES = gql`
  mutation SubscribeInstagramPages(
    $pageIds: [String!]!
    $accessTokens: [String!]!
  ) {
    subscribeInstagramPages(pageIds: $pageIds, accessTokens: $accessTokens) {
      success
      error
      result
    }
  }
`;

export default SUBSCRIBE_INSTAGRAM_PAGES;
